var $a9daab48d18bec17$exports = {};
$a9daab48d18bec17$exports = {
    "longPressMessage": `Dlouh\xfdm stiskem nebo stisknut\xedm kl\xe1ves Alt + \u{161}ipka dol\u{16F} otev\u{159}ete nab\xeddku`
};


export {$a9daab48d18bec17$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
